import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "space-y-4" }
const _hoisted_2 = { class: "flex items-center space-x-2" }
const _hoisted_3 = { class: "flex space-x-2 flex-wrap" }
const _hoisted_4 = { class: "flex items-center space-x-2" }
const _hoisted_5 = { class: "flex space-x-2 flex-wrap" }
const _hoisted_6 = { class: "flex items-center space-x-2" }
const _hoisted_7 = { class: "flex space-x-2 flex-wrap" }
const _hoisted_8 = { class: "flex items-center space-x-2" }
const _hoisted_9 = { class: "flex space-x-2 flex-wrap" }

import { ref, computed, watch } from 'vue';
import BaseInput from '../forms/BaseInput.vue';

import type { ProductSize, SizeInput } from '@/types'

// Props spécifiques au composant InputSize
interface Props {
  modelValue?: ProductSize[];
  availableSizes?: string[];
  disabled?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'InputSize',
  props: {
    modelValue: { default: () => [] },
    availableSizes: { default: () => [] },
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "save"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// Événements
const emit = __emit;

// Réactivité
const frenchSizes = ref<SizeInput[]>([
  { value: '', placeholder: 'XS', available: true },
  { value: '', placeholder: 'S', available: true },
  { value: '', placeholder: 'M', available: true },
  { value: '', placeholder: 'L', available: true },
  { value: '', placeholder: 'XL', available: true },
  { value: '', placeholder: 'XXL', available: true },
  { value: '', placeholder: '3XL', available: true },
  { value: '', placeholder: '4XL', available: true },
  { value: '', placeholder: '5XL', available: true }
]);

const ukSizes = ref<SizeInput[]>([
  { value: '', placeholder: '6', available: true },
  { value: '', placeholder: '8', available: true },
  { value: '', placeholder: '10', available: true },
  { value: '', placeholder: '12', available: true },
  { value: '', placeholder: '14', available: true },
  { value: '', placeholder: '16', available: true },
  { value: '', placeholder: '18', available: true },
  { value: '', placeholder: '20', available: true },
  { value: '', placeholder: '22', available: true }
]);

const euSizes = ref<SizeInput[]>([
  { value: '', placeholder: '34', available: true },
  { value: '', placeholder: '36', available: true },
  { value: '', placeholder: '38', available: true },
  { value: '', placeholder: '40', available: true },
  { value: '', placeholder: '42', available: true },
  { value: '', placeholder: '44', available: true },
  { value: '', placeholder: '46', available: true },
  { value: '', placeholder: '48', available: true },
  { value: '', placeholder: '50', available: true }
]);

const usSizes = ref<SizeInput[]>([
  { value: '', placeholder: '2', available: true },
  { value: '', placeholder: '4', available: true },
  { value: '', placeholder: '6', available: true },
  { value: '', placeholder: '8', available: true },
  { value: '', placeholder: '10', available: true },
  { value: '', placeholder: '12', available: true },
  { value: '', placeholder: '14', available: true },
  { value: '', placeholder: '16', available: true },
  { value: '', placeholder: '18', available: true }
]);

// Computed
const allSizes = computed(() => {
  const sizes: ProductSize[] = [];
  
  // Tailles françaises
  frenchSizes.value.forEach((size, index) => {
    if (size.value) {
      sizes.push({
        id: `fr-${index}`,
        name: size.value,
        available: size.available,
        stock: 0
      });
    }
  });
  
  // Tailles UK
  ukSizes.value.forEach((size, index) => {
    if (size.value) {
      sizes.push({
        id: `uk-${index}`,
        name: size.value,
        available: size.available,
        stock: 0
      });
    }
  });
  
  // Tailles EU
  euSizes.value.forEach((size, index) => {
    if (size.value) {
      sizes.push({
        id: `eu-${index}`,
        name: size.value,
        available: size.available,
        stock: 0
      });
    }
  });
  
  // Tailles US
  usSizes.value.forEach((size, index) => {
    if (size.value) {
      sizes.push({
        id: `us-${index}`,
        name: size.value,
        available: size.available,
        stock: 0
      });
    }
  });
  
  return sizes;
});

// Méthodes
const updateFrenchSize = (index: number, value: string) => {
  frenchSizes.value[index].value = value;
  emit('update:modelValue', allSizes.value);
};

const updateUkSize = (index: number, value: string) => {
  ukSizes.value[index].value = value;
  emit('update:modelValue', allSizes.value);
};

const updateEuSize = (index: number, value: string) => {
  euSizes.value[index].value = value;
  emit('update:modelValue', allSizes.value);
};

const updateUsSize = (index: number, value: string) => {
  usSizes.value[index].value = value;
  emit('update:modelValue', allSizes.value);
};

const resetSizes = () => {
  frenchSizes.value.forEach(size => size.value = '');
  ukSizes.value.forEach(size => size.value = '');
  euSizes.value.forEach(size => size.value = '');
  usSizes.value.forEach(size => size.value = '');
  emit('update:modelValue', []);
};

const saveSizes = () => {
  emit('save', allSizes.value);
};

// Watchers
watch(() => props.modelValue, (newSizes) => {
  // Mettre à jour les inputs si les props changent
  if (newSizes && newSizes.length > 0) {
    // Logique pour remplir les inputs avec les valeurs existantes
  }
}, { deep: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, "Grille de tailles", -1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("img", {
        src: "https://www.efashion-paris.loc/core/img/admin/fr.gif",
        alt: "France",
        class: "w-6 h-4"
      }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(frenchSizes.value, (size, index) => {
          return (_openBlock(), _createBlock(BaseInput, {
            key: `fr-${index}`,
            modelValue: size.value,
            "onUpdate:modelValue": [($event: any) => ((size.value) = $event), ($event: any) => (updateFrenchSize(index, $event as string))],
            placeholder: size.placeholder,
            type: "text",
            class: "w-16"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[1] || (_cache[1] = _createElementVNode("img", {
        src: "https://www.efashion-paris.loc/core/img/admin/uk.gif",
        alt: "UK",
        class: "w-6 h-4"
      }, null, -1)),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ukSizes.value, (size, index) => {
          return (_openBlock(), _createBlock(BaseInput, {
            key: `uk-${index}`,
            modelValue: size.value,
            "onUpdate:modelValue": [($event: any) => ((size.value) = $event), ($event: any) => (updateUkSize(index, $event as string))],
            placeholder: size.placeholder,
            type: "text",
            class: "w-16"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _cache[2] || (_cache[2] = _createElementVNode("img", {
        src: "https://www.efashion-paris.loc/core/img/admin/eu.gif",
        alt: "EU",
        class: "w-6 h-4"
      }, null, -1)),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(euSizes.value, (size, index) => {
          return (_openBlock(), _createBlock(BaseInput, {
            key: `eu-${index}`,
            modelValue: size.value,
            "onUpdate:modelValue": [($event: any) => ((size.value) = $event), ($event: any) => (updateEuSize(index, $event as string))],
            placeholder: size.placeholder,
            type: "text",
            class: "w-16"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _cache[3] || (_cache[3] = _createElementVNode("img", {
        src: "https://www.efashion-paris.loc/core/img/admin/us.gif",
        alt: "US",
        class: "w-6 h-4"
      }, null, -1)),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usSizes.value, (size, index) => {
          return (_openBlock(), _createBlock(BaseInput, {
            key: `us-${index}`,
            modelValue: size.value,
            "onUpdate:modelValue": [($event: any) => ((size.value) = $event), ($event: any) => (updateUsSize(index, $event as string))],
            placeholder: size.placeholder,
            type: "text",
            class: "w-16"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", { class: "flex justify-end space-x-2 mt-4" }, [
      _createElementVNode("button", {
        onClick: resetSizes,
        class: "px-3 py-2 text-sm border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
      }, _cache[4] || (_cache[4] = [
        _createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1),
        _createTextVNode("Réinitialiser ")
      ])),
      _createElementVNode("button", {
        onClick: saveSizes,
        class: "px-3 py-2 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
      }, _cache[5] || (_cache[5] = [
        _createElementVNode("i", { class: "fas fa-save mr-2" }, null, -1),
        _createTextVNode("Sauvegarder ")
      ]))
    ])
  ]))
}
}

})